import shouldForwardProp from '@styled-system/should-forward-prop'
import React from 'react'
import styled from 'styled-components'
import { color, space, typography } from 'styled-system'

export const BaseHeading = styled('h1')
  .withConfig({ shouldForwardProp })
  .attrs((props) => ({
    fontFamily: props.fontFamily || 'system-ui, sans-serif',
    fontSize: props.fontSize || 3,
    lineHeight: props.lineHeight || 1,
    color: props.color || 'grayheading',
    mt: 0,
    mb: 0,
    ...props,
  }))(
  {
    fontFamily: 'inherit',
  },
  typography,
  color,
  space,
  (props) => props.css,
)

// Used for Logbook / Lists / Schedule headings
export const Heading = ({ darkMode, ...props }) => (
  <BaseHeading
    as="h1"
    fontSize={30}
    fontWeight={700}
    mb={4}
    color={darkMode ? 'white' : 'black'}
    {...props}
  />
)

// used for the text under Heading - "Actions this week" or "Completed Actions"
export const SubHeading = ({ darkMode, ...props }) => (
  <BaseHeading
    fontSize={0}
    fontWeight="normal"
    color={darkMode ? 'white' : 'black'}
    mb={4}
    {...props}
  />
)

// used for Today, Tomorrow, ... in schedule,
// This week, Last Week, ... in logbook
export const SectionTitle = ({ darkMode, ...props }) => (
  <BaseHeading
    as="h2"
    fontSize={19}
    fontWeight={700}
    color={darkMode ? 'white' : 'black'}
    mb={1}
    {...props}
  />
)
